import { __awaiter } from "tslib";
export class ZLoadingService {
    constructor() {
        this.id = 0;
        this.promises = {};
        this.errors = [];
        Object.assign(globalThis, { Loading: this });
    }
    nextId() { return 'Z' + (this.id++).toString(16); }
    await(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const isArray = Array.isArray(args);
            if (!isArray) {
                args = [args];
            }
            const id = this.nextId();
            try {
                this.setState({ visible: true });
                const promise = Promise.all(args);
                this.promises[id] = [promise, new Error('').stack || ''];
                const result = yield promise;
                delete this.promises[id];
                this.checkIfFinished();
                return isArray ? result : result[0];
            }
            catch (err) {
                this.errors.push(this.parseError(err));
                delete this.promises[id];
                this.checkIfFinished();
                throw err;
            }
        });
    }
    parseError(err) {
        return (err && typeof err === 'string') ? new Error(err) : err;
    }
    checkIfFinished() {
        this.setState({
            visible: (Object.keys(this.promises).length > 0)
        });
    }
    setState({ visible }) {
        $('.loading-stripe').toggleClass('done', !visible);
        $('.card-body form.has-loader').toggleClass('loader-active', visible);
        $('.loading-desktop').toggleClass('done', !visible);
        $('.loading-blocker').css('left', Math.max($('.side-panel').outerWidth(), 0));
    }
    reset() {
        this.promises = {};
        this.errors = [];
        this.checkIfFinished();
    }
}
//# sourceMappingURL=loading.js.map